module.exports = __webpack_public_path__ + "static/media/torsion.5b5ddf58.jpeg";